import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Stack,
  Typography,
} from '@mui/material';
import { Chart, registerables } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import React, { useMemo, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { useSelector } from 'react-redux';

import i18n from 'FRONTEND/utils/i18n';

import 'chartjs-adapter-dayjs-3';

Chart.register(...registerables, zoomPlugin);

const isTouchScreen = navigator.maxTouchPoints > 1;

const VitalLineChart = ({
  serie,
  label,
  color,
  unit,
  icon,
}) => {
  const [expanded, setExpanded] = useState(true);
  const locale = useSelector((state) => state.user.locale);

  // Memoized since the "serie" is iterated over and may be long.
  const lineData = useMemo(() => ({
    datasets: [{
      data: serie.map(([x, y]) => ({ x: new Date(x), y: parseFloat(y) })),
      label,
      borderColor: color,
    }],
  }), [serie, label, color]);

  const lineChartOptions = {
    locale,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => context.parsed.y != null ? `${new Intl.NumberFormat(locale).format(context.parsed.y)} ${unit}` : '',
        },
      },
      zoom: {
        pan: {
          enabled: true,
          mode: 'xy',
        },
        zoom: {
          wheel: {
            enabled: true,
            modifierKey: isTouchScreen ? null : 'ctrl',
          },
          pinch: {
            enabled: true,
          },
          mode: 'xy',
        },
      },
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'hour',
          displayFormats: {
            second: 'DD/MM/YYYY HH:mm:ss',
            minute: 'DD/MM/YYYY HH:mm',
            hour: 'DD/MM/YYYY HH:mm',
            day: 'DD/MM/YYYY',
            week: 'DD/MM/YYYY',
            month: 'MMM YYYY',
            quarter: 'MMM YYYY',
            year: 'YYYY',
          },
          tooltipFormat: 'DD/MM/YYYY HH:mm',
        },
      },
      y: {
        title: {
          color,
          display: true,
          text: unit,
        },
      },
    },
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      sx={{ mb: 1 }}
      square
    >
      <AccordionSummary
        style={{ backgroundColor: color }}
        sx={{ pl: 2, width: '100%', backgroundColor: color }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Stack
          direction='row'
          alignItems='center'
          spacing={1}
        >
          {icon && (
            <Avatar src={icon} variant='square' />
          )}
          <Typography>
            {label}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ mb: 1 }}>
        {!isTouchScreen && <Typography variant='caption'>{i18n._('Use ctrl+mouse wheel to zoom.')}</Typography>}
        <Line options={lineChartOptions} data={lineData} />
      </AccordionDetails>
    </Accordion>
  );
};

export default VitalLineChart;
